import CityPageTemplate from "../city-template/CityPageTemplate";
import { vailConfig } from "./data";

export default function VailPage() {
  return <CityPageTemplate config={vailConfig} />;
}